import React from "react";
import dayjs from "dayjs";
import Flex from "@src/@core/components/ui-components/flex";

const HeatMap = ({ heatMapData = [] }) => {
    const createHeatMapArray = () => {
        const heatMapArray = new Array(7).fill(null);
        heatMapData.forEach((item, index) => {
            if (index < 7) {
                heatMapArray[index] = {
                    count: item.count,
                    date : item.created_at
                };
            }
        });
        return heatMapArray;
    };
    const heatMapArray = createHeatMapArray();
    const maxCount = Math.max(...heatMapArray.map(item => item?.count || 0), 1);

    const getHeatMapColor = (count) => {
        if (count === 0) return "#4AC4BB1A";
        const intensity = Math.min(count / maxCount, 1);
        if (intensity < 0.2) return "#4AC4BB66";
        if (intensity < 0.4) return "#4AC4BB80";
        if (intensity < 0.6) return "#4AC4BB99";
        if (intensity < 0.8) return "#4AC4BBCC";
        return "#4AC4BB";
    };

    return (
        <Flex>
            {heatMapArray.map((item, index) => {
                const count = item?.count || 0;
                const date = item?.date;
                const hasData = count > 0;

                return (
                    <div
                        key={index}
                        className={`heatmap ${hasData ? "has-data" : "no-data"}`}
                        style={{
                            backgroundColor: getHeatMapColor(count)
                        }}
                        title={
                            hasData && date ? `${dayjs(date).format("MMM D, YYYY")}\nCount: ${count}` : "No data"
                        }
                        onMouseEnter={(e) => {
                            if (hasData) {
                                e.target.style.transform = "scale(1.3)";
                                e.target.style.zIndex = "10";
                                e.target.style.boxShadow = "0 2px 8px rgba(204, 85, 0, 0.3)";
                            }
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.transform = "scale(1)";
                            e.target.style.zIndex = "1";
                            e.target.style.boxShadow = hasData ? "0 1px 2px rgba(0,0,0,0.1)" : "none";
                        }}/>
                );
            })}
        </Flex>
    );
};

export default HeatMap;
